// extracted by mini-css-extract-plugin
module.exports = {"welcome":"SessionHadEndedMessage_welcome__xAvM1","welcome-introduction":"SessionHadEndedMessage_welcome-introduction__3Uzzy"};